import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"

import {
  getAgreementSelection,
  putAdvertisingAgreement,
  putPersonalRelationAgreement,
  putThirdPartyAgreement,
} from "actions"

const useAgreementSelection = () => {
  const dispatch = useDispatch()
  return {
    agreementSelection: useSelector(state => state.agreementSelection),
    getAgreementSelection: useCallback(
      () => dispatch(getAgreementSelection()),
      [dispatch]
    ),

    putAdvertisingAgreement: useCallback(
      advertisingAgreement =>
        dispatch(putAdvertisingAgreement(advertisingAgreement)),
      [dispatch]
    ),

    putPersonalRelationAgreement: useCallback(
      personalRelationAgreement =>
        dispatch(putPersonalRelationAgreement(personalRelationAgreement)),
      [dispatch]
    ),

    putThirdPartyAgreement: useCallback(
      thirdPartyAgreement =>
        dispatch(putThirdPartyAgreement(thirdPartyAgreement)),
      [dispatch]
    ),
  }
}
export default useAgreementSelection
